import React, { memo, SVGProps } from 'react'

export const StatusIgnored = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12.0533 19.2853C8 19.2853 4.704 16 4.704 11.936C4.704 8.30933 7.33867 5.30133 10.7947 4.704C9.94133 5.74933 9.42933 7.072 9.42933 8.52267C9.42933 11.8507 12.128 14.5493 15.456 14.5493C16.9067 14.5493 18.24 14.0373 19.2747 13.184C18.6773 16.64 15.6693 19.2747 12.0427 19.2747L12.0533 19.2853Z"
      fill="currentColor"
    />
  </svg>
))
